import React, {useState} from "react";

import API from "../Global/API";
import {useAuth} from "../Global/Auth";
import MassMailForm from "./MassMailActions/MassMailForm";
import DialogHeading from "../Components/Typography/DialogHeading";

import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * MassMailActions component.
 *
 * @returns {*}
 * @constructor
 */
const MassMailActions = (props) => {
    const {
        record,         // {Object} The target record / context.
        doReload,       // {Function} Reloads the parent layout, if applicable.
    } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const [isEditing, setEditing] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isConfirmingDelete, setConfirmDelete] = useState(false);
    const {hasPermissionTo, hasOneOfPermissions, hasAllPermissions} = useAuth();

    /**
     * Indicates whether an anchor target exists for the menu.
     *
     * @type {boolean}
     */
    const open = Boolean(anchorEl);


    /**
     * Fired whenever the menu button is clicked.
     *
     * @param event
     */
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };


    /**
     * Closes the menu popover.
     */
    const handleClose = () => {
        setAnchorEl(null);
    };


    /**
     * Reveals the employee edit form.
     */
    const handleMassMailEditOpen = () => {
        handleClose();
        setEditing(true);
    };


    /**
     * Hides the employee edit form.
     */
    const handleMassMailEditClose = () => {
        setEditing(false);
    };


    /**
     * Handles the employee record save.
     */
    const handleMassMailSave = (record) => {
        handleMassMailEditClose();

        if (doReload) {
            doReload(record);
        }
    };


    /**
     * Reveals the delete confirmation.
     */
    const handleDeleteConfirmOpen = () => {
        setConfirmDelete(true);
    };


    /**
     * Hides the delete confirmation.
     */
    const handleDeleteConfirmClose = () => {
        setConfirmDelete(false);
    };


    /**
     * Processes the delete action.
     *
     * @returns {Promise<void>}
     */
    const doDelete = async () => {
        setLoading(true);

        const response = await API.put(`mass-mail/${record.id}`, {
            isDeleted: true
        });

        if(doReload){
            doReload(response);
        }

        setLoading(false);
        setConfirmDelete(false);
    };

    return (
        <div>
            {hasOneOfPermissions(['EDIT_COMMUNICATIONS', 'DELETE_COMMUNICATIONS']) && (
                <IconButton onClick={handleClick}>
                    <MoreHorizIcon/>
                </IconButton>
            )}

            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                {hasPermissionTo('EDIT_COMMUNICATIONS') && (
                    <MenuItem onClick={handleMassMailEditOpen}>Edit Campaign</MenuItem>
                )}

                {hasAllPermissions(['EDIT_COMMUNICATIONS', 'DELETE_COMMUNICATIONS']) && (
                    <Divider/>
                )}

                {hasPermissionTo('DELETE_COMMUNICATIONS') && (
                    <MenuItem
                        onClick={handleDeleteConfirmOpen}
                        disabled={record.isDeleted}
                        className={'menu__error'}
                    >Delete Record</MenuItem>
                )}
            </Menu>

            {isEditing && (
                <MassMailForm
                    open={true}
                    record={record}
                    onSave={handleMassMailSave}
                    onClose={handleMassMailEditClose}
                />
            )}

            {isConfirmingDelete && (
                <Dialog
                    open={isConfirmingDelete}
                    scroll={'body'}
                    onClose={handleDeleteConfirmClose}
                    maxWidth={'xs'}
                    fullWidth
                >
                    <DialogHeading
                        title={"Confirm Delete"}
                        noMargin
                    />
                    <DialogContent>
                        Are you sure that you'd like to delete this record?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={doDelete}
                            children={'Delete'}
                            disabled={isLoading}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
};

export default MassMailActions;